import { Box, Link, styled, Theme, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { SubcategoriesStaticData } from "data/categories";
import { capitalize } from "helpers/algoliaUtils";
import DropdownList from "../../../components/design-system/organisms/DropdownList/DropdownList";

const CategoryItem = styled(Link)<Theme, any>(({ item }) => ({
  cursor: "pointer",
  fontWeight: item.isRefined ? 500 : "normal",
  textDecoration: item.isRefined ? "underline" : "",
  color: item.isRefined ? "#1B1E1C" : "#3E3E3E",
}));

// Could not use MenuProvided from react-instantsearch-core
interface MenuProvidedWithItems {
  isRefined: boolean;
  label: string;
  value: string;
  items: MenuProvidedWithItems[];
  createURL: (...args: any[]) => any;
  refine: (...args: any[]) => any;
}

const NoItemsSkeleton = () => {
  return (
    <Box justifyContent={"space-around"} display={"flex"}>
      {["1", "2", "3", "4"].map((item) => (
        <Typography key={item} variant="h1">
          <Skeleton width={200} />
        </Typography>
      ))}
    </Box>
  );
};

const NavbarItem = ({ item, createURL, refine }) => {
  return (
    <Box height={20} fontSize={16} my={"auto"} mr={"20px"}>
      <CategoryItem
        role="button"
        tabIndex={0}
        item={item}
        href={createURL(item.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            refine(item.value);
          }
        }}
        onClick={(event) => {
          event.preventDefault();
          refine(item.value);
        }}
      >
        {SubcategoriesStaticData.find((cat) => cat.slug === item.label)?.name || capitalize(item.label)}
      </CategoryItem>
    </Box>
  );
};

const NavbarWrapper = ({ items, createURL, refine }) => {
  return items.map((item) => (
    <NavbarItem key={item.label} item={item} createURL={createURL} refine={refine}></NavbarItem>
  ));
};

export default function DesktopMenu(menuProvided: MenuProvidedWithItems, catalogName: string) {
  const MAX_DISPLAYED_ITEMS = 4;

  const findFirstRefined = (menu: MenuProvidedWithItems): MenuProvidedWithItems | undefined => {
    if (!menu || !menu.items) {
      return undefined;
    }
    return menu.items.find((item) => item.isRefined);
  };

  const refinedItem: MenuProvidedWithItems | undefined = findFirstRefined(menuProvided);

  const items = menuProvided.items && refinedItem ? refinedItem.items : menuProvided.items;

  if (!items) {
    return null;
  } else if (items.length === 0) {
    return NoItemsSkeleton;
  } else if (items?.length && items?.length <= MAX_DISPLAYED_ITEMS) {
    return (
      <Box justifyContent={"end"} display={"flex"}>
        <NavbarWrapper items={items} refine={menuProvided.refine} createURL={menuProvided.createURL}></NavbarWrapper>
      </Box>
    );
  }

  return (
    <Box justifyContent={"end"} display={"flex"} flexWrap="wrap">
      <NavbarWrapper
        items={items.slice(0, MAX_DISPLAYED_ITEMS)}
        refine={menuProvided.refine}
        createURL={menuProvided.createURL}
      ></NavbarWrapper>
      <Box style={{ margin: "auto 0" }}>
        <DropdownList
          defaultRefinement={catalogName}
          fontSize="16px"
          items={[
            ...items.slice(MAX_DISPLAYED_ITEMS, items.length),
            {
              value: catalogName,
              label: "Voir " + (items.length - MAX_DISPLAYED_ITEMS) + " de plus",
              isRefined: false,
              items: [],
            },
          ]}
          refine={menuProvided.refine}
          scrollToTop={() => undefined}
          isCategoryDropdown={true}
        ></DropdownList>
      </Box>
    </Box>
  );
}
